<div class="country-select-container">
  <ng-select
    [items]="countries"
    bindLabel="name"
    bindValue="isoCode"
    [(ngModel)]="selectedIso"
    (change)="changeCountry()"
    [clearable]="false"
    [searchable]="false"
  >
    <ng-template ng-label-tmp let-item="item">
      <img *ngIf="item" [alt]="item.name" [src]="'https://flagcdn.com/w40/' + item.isoCode.toLowerCase() + '.png'" />
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <img [alt]="item.name" [src]="'https://flagcdn.com/w40/' + item.isoCode.toLowerCase() + '.png'" />
    </ng-template>
  </ng-select>
</div>